module.exports = __webpack_public_path__ + "img/c03_unithorsemanchampion_Normal_ua.3b0af2b1.webp";